import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { blogAPI } from '@/lib/api';
import { toast } from 'sonner';
import { Calendar, ArrowRight } from 'lucide-react';

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const response = await blogAPI.getAll(true);
      setBlogs(response.data);
    } catch (error) {
      console.error('Error fetching blogs:', error);
      toast.error('Bloglar yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Blog - Aden İklimlendirme</title>
        <meta name="description" content="Klima, kombi ve beyaz eşya hakkında faydalı bilgiler ve ipucları." />
      </Helmet>

      <Navbar />

      <section className="py-20 md:py-32" data-testid="blog-page">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-navy mb-4">Blog</h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Klima, kombi ve beyaz eşya bakımı hakkında ipucları ve bilgiler.
            </p>
          </div>

          {loading ? (
            <div className="text-center py-20">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-navy border-t-transparent"></div>
              <p className="mt-4 text-slate-600">Yükleniyor...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className="text-center py-20" data-testid="no-blogs">
              <p className="text-lg text-slate-600">Henüz blog yazısı eklenmemiş.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
              {blogs.map((blog) => (
                <Link
                  key={blog.id}
                  to={`/blog/${blog.slug}`}
                  data-testid={`blog-card-${blog.slug}`}
                  className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-lg transition-all hover:-translate-y-1"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={blog.cover_image}
                      alt={blog.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center text-sm text-slate-500 mb-3">
                      <Calendar size={16} className="mr-2" />
                      {new Date(blog.created_at).toLocaleDateString('tr-TR')}
                    </div>
                    <h3 className="text-xl font-bold text-navy mb-3 line-clamp-2">{blog.title}</h3>
                    <div className="flex items-center text-orange font-semibold">
                      Devamını Oku
                      <ArrowRight className="ml-2" size={18} />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default BlogPage;
